module.exports = __webpack_public_path__ + "static/media/brand-logo.75a0bac7.svg";